import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { MotionConfig } from "motion/react";
import "./styles.css";
import { queryClient, trpcClient, TRPCProvider } from "./lib/trpc";
import { router } from "./router";
import { ToastProvider } from "./ui/kit";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
        <MotionConfig reducedMotion="user">
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </MotionConfig>
      </TRPCProvider>
    </QueryClientProvider>
  </StrictMode>,
);
